module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-12.7cb7dcf7.jpg";